<template>
  <div>
    <div v-if="!text">
      <canvas
        id="myChart44"
        width="30"
        height="10"
      />
    </div>
    <div
      v-else
    >
      {{ text }}
    </div>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import eventEmit from '../../../components/core/EventoEmit'

  export default {
    name: 'DashboardPorcentagemMixComercializado',
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
    },

    data: () => ({
      myChart: {},
      styleCliente: {
        color: '#ed934f',
      },
      enableGrafico: true,
      text: null,
      montaGrafico: true,
      porcentagem: 0,
      porcentagemRestante: 0,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
    }),

    created () {
      eventEmit.$on('set-dados-mix-comercializado', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-dados-mix-comercializado', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (porcentagem, porcentagemRestante) {
        this.porcentagem = porcentagem
        this.porcentagemRestante = porcentagemRestante

        this.montarGrafico()
      },

      montarGrafico () {
        if (this.myChart.data) {
          this.myChart.destroy()
        }

        const ctx = document.getElementById('myChart44').getContext('2d')

        this.myChart = new Chart(ctx, {
          plugins: [ChartDataLabels],
          type: 'horizontalBar',
          data: {
            labels: [''],
            datasets: [
              {
                label: 'Porcentagem',
                data: [this.porcentagem],
                backgroundColor: '#4780b8',
                order: 1,
                barPercentage: 0.1,
              },
              {
                label: 'Porcentagem Restante',
                data: [this.porcentagemRestante],
                backgroundColor: '#cadaed',
                order: 2,
                barPercentage: 0.1,
              },
            ],
          },
          options: {
            plugins: {
              datalabels: {
                display: false,
                color: function (context) {
                  if (context.dataset.label === 'Porcentagem') {
                    return '#000000'
                  } else {
                    return 'transparent'
                  }
                },
                font: {
                  size: 11,
                },
                formatter: (value) => {
                  return value.toFixed(2).toString().replace('.', ',') + '%'
                },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
              },
              xAxes: [{
                stacked: true,
                gridLines: {
                  display: false,
                },
                display: false,
              }],
              yAxes: [{
                stacked: true,
                gridLines: {
                  display: false,
                },
                color: 'transparent',
              }],
            },
            legend: {
              display: false,
            },
            tooltips: {
              callbacks: {
                mode: 'label',
                label: (tooltipItem, data) => {
                  var type = data.datasets[tooltipItem.datasetIndex].label
                  var valor = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2).toString().replace('.', ',') + '%'

                  return type + ': ' + valor
                },
                title: (tooltipItem) => {
                  return 'Progresso atingimento da meta'
                },
              },
            },
          },
        })
      },
    },
  }
</script>

<style scoped>
  @media only screen
  and (min-device-width : 320px)
  and (max-device-width : 480px) {

  }
</style>

<style lang="sass">

</style>
